// extracted by mini-css-extract-plugin
export default {"title":"meTextSection-module__title___22AXD","text":"meTextSection-module__text___uTKca"};